module.exports = __webpack_public_path__ + "static/media/fc_preview_profile_image.425c73a5.png";